import React, { useState, useEffect } from 'react';
import { FormControl, Select, MenuItem, Box, Typography } from '@mui/material';

function CountrySwitcher() {
  const [roles, setRoles] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState('TN');

  useEffect(() => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    let isSuperUser = false;
    if (token) {
      try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        if (payload.roles) {
          setRoles(payload.roles);
          isSuperUser = payload.roles.includes('superuser');
        }
      } catch (e) {
        console.error(e);
      }
    }
    const saved = localStorage.getItem('x-country-override');
    if (saved) {
      setSelectedCountry(saved);
    } else if (isSuperUser) {
      // Default to TN for superusers on their first login or if override is missing
      localStorage.setItem('x-country-override', 'TN');
      setSelectedCountry('TN');
      // Do a silent reload or let the next request pick it up
    }
  }, []);

  const handleChange = (e) => {
    const newVal = e.target.value;
    setSelectedCountry(newVal);
    localStorage.setItem('x-country-override', newVal);
    // Reload to apply the new context across the app
    window.location.reload();
  };

  if (!roles.includes('superuser')) {
    return null;
  }

  return (
    <Box sx={{ ml: 2, display: 'flex', alignItems: 'center' }}>
      <Typography variant="body2" sx={{ mr: 1, fontWeight: 'bold' }}>
        Managing Country:
      </Typography>
      <FormControl size="small" variant="outlined">
        <Select
          value={selectedCountry}
          onChange={handleChange}
          sx={{
            height: '35px',
            backgroundColor: '#f5f5f5',
            '& .MuiSelect-select': { py: 0.5 }
          }}
        >
          <MenuItem value="TN">Tunisia (TN)</MenuItem>
          <MenuItem value="DZ">Algeria (DZ)</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
}

export default CountrySwitcher;